import { SURVEY_STATUS } from '../enums/survey-status.enum';
import { PmfScore } from './pmf-score.interface';

export interface SurveySummary {
    _id: string;
    status: SURVEY_STATUS;
    startDate: Date;
    endDate: Date | undefined;
    pmfResult: PmfScore;
    responseCount: number;
    distribution: {
        veryDisappointed: number;
        somewhatDisappointed: number;
        notDisappointed: number;
    };
}
